<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Gerätegruppierung"}}{{#if oriGroupName}} - {{oriGroupName}}{{/if}}</h4>
</div>
<div class="modal-body">
    {{ERROR_ROW errors.error}}
    {{#WIZARD wizardContext}}
        {{#if filterConfig.isFilter}}
        {{#WIZARD-TAB 'Filter'}}
            {{{DEVICE-FILTER filterConfig}}}
        {{/WIZARD-TAB}}
        {{/if}}
        {{#WIZARD-TAB 'Devices'}}
            {{{DEVICE-SELECT filterConfig}}}
        {{/WIZARD-TAB}}
        {{#WIZARD-TAB 'Group'}}
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-12 m-t-15">
                        <label class="control-label" for="name-edt">{{TR "Name"}}</label>
                        <input type="text" class="form-control {{#if errors.name}}parsley-error{{/if}}" value="{{data.name}}" id="name-edt">
                        {{#if errors.name}}
                        <ul class="parsley-errors-list filled">
                            <li class="parsley-required">{{errors.name}}</li>
                        </ul>
                        {{/if}}
                    </div>
                </div>
            </div>
        {{/WIZARD-TAB}}
    {{/WIZARD}}
</div>
<div class="modal-footer">
    {{{WIZARD-BUTTONS wizardContext}}}
</div>
